var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 2.15625C15.2652 2.15625 13.6562 3.76523 13.6562 5.75C13.6562 6.07188 13.6987 6.38447 13.7785 6.68216L8.57801 9.28241C7.92066 8.44528 6.89871 7.90625 5.75 7.90625C3.76523 7.90625 2.15625 9.51523 2.15625 11.5C2.15625 13.4848 3.76523 15.0938 5.75 15.0938C6.89871 15.0938 7.92066 14.5547 8.57801 13.7176L13.7785 16.3178C13.6987 16.6155 13.6562 16.9281 13.6562 17.25C13.6562 19.2348 15.2652 20.8438 17.25 20.8438C19.2348 20.8438 20.8438 19.2348 20.8438 17.25C20.8438 15.2652 19.2348 13.6562 17.25 13.6562C16.1013 13.6562 15.0793 14.1953 14.422 15.0324L9.22149 12.4322C9.30127 12.1345 9.34375 11.8219 9.34375 11.5C9.34375 11.1781 9.30127 10.8655 9.22149 10.5678L14.422 7.96759C15.0793 8.80472 16.1013 9.34375 17.25 9.34375C19.2348 9.34375 20.8438 7.73477 20.8438 5.75C20.8438 3.76523 19.2348 2.15625 17.25 2.15625Z",
    fill: "url(#paint0_linear_2033_19829)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2033_19829",
    x1: 2.16968,
    y1: 11.5,
    x2: 20.8572,
    y2: 11.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D802BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B7DB1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShare);
export default __webpack_public_path__ + "static/media/icon_share.79aae3f7cf316458863454e5e67008c8.svg";
export { ForwardRef as ReactComponent };